import React from 'react';

const NotFoundPage = () => (
  <div className="section" style={{ textAlign: 'center' }}>
    <h2>404: Page Not Found</h2>
    <p>Oops, that route doesn’t exist.</p>
  </div>
);

export default NotFoundPage;